import { Key } from 'protractor';
import { MEDIA_FILE } from '../message/file-element/fileMap';
import { MessageElement } from '../model';

export const EMOJI_URL = "/assets/img/emoji/";
export const MEDIA_IMG = '66D85069-4B5B-4A13-97C7-7DE81F398FC3';
export const MEDIA_VIDEO = 'F5863B08-6E99-4BF8-9864-865A04AE78C2';
export const EMOJI_MAP = {
    '[微笑]': '100.gif',
    '[撇嘴]': '101.gif',
    '[色]': '102.gif',
    '[发呆]': '103.gif',
    '[得意]': '104.gif',
    '[流泪]': '105.gif',
    '[害羞]': '106.gif',
    '[闭嘴]': '107.gif',
    '[睡]': '108.gif',
    '[大哭]': '109.gif',
    '[尴尬]': '110.gif',
    '[发怒]': '111.gif',
    '[调皮]': '112.gif',
    '[呲牙]': '113.gif',
    '[惊讶]': '114.gif',
    '[难过]': '115.gif',
    '[酷]': '116.gif',
    '[囧]': '117.gif',
    '[抓狂]': '118.gif',
    '[吐]': '119.gif',
    '[偷笑]': '120.gif',
    '[愉快]': '121.gif',
    '[白眼]': '122.gif',
    '[傲慢]': '123.gif',
    '[饥饿]': '124.gif',
    '[困]': '125.gif',
    '[惊恐]': '126.gif',
    '[流汗]': '127.gif',
    '[憨笑]': '128.gif',
    '[悠闲]': '129.gif',
    '[奋斗]': '130.gif',
    '[咒骂]': '131.gif',
    '[疑问]': '132.gif',
    '[嘘]': '133.gif',
    '[晕]': '134.gif',
    '[疯了]': '135.gif',
    '[衰]': '136.gif',
    '[骷髅]': '137.gif',
    '[敲打]': '138.gif',
    '[再见]': '139.gif',
    '[擦汗]': '140.gif',
    '[抠鼻]': '141.gif',
    '[鼓掌]': '142.gif',
    '[糗大了]': '143.gif',
    '[坏笑]': '144.gif',
    '[左哼哼]': '145.gif',
    '[右哼哼]': '146.gif',
    '[哈切]': '147.gif',
    '[鄙视]': '148.gif',
    '[委屈]': '149.gif',
    '[快哭]': '150.gif',
    '[阴险]': '151.gif',
    '[亲亲]': '152.gif',
    '[吓]': '153.gif',
    '[可怜]': '154.gif',
    '[菜刀]': '155.gif',
    '[西瓜]': '156.gif',
    '[啤酒]': '157.gif',
    '[篮球]': '158.gif',
    '[乒乓]': '159.gif',
    '[咖啡]': '160.gif',
    '[饭]': '161.gif',
    '[猪头]': '162.gif',
    '[玫瑰]': '163.gif',
    '[凋谢]': '164.gif',
    '[嘴唇]': '165.gif',
    '[爱心]': '166.gif',
    '[心碎]': '167.gif',
    '[蛋糕]': '168.gif',
    '[闪电]': '169.gif',
    '[炸弹]': '170.gif',
    '[刀]': '171.gif',
    '[足球]': '172.gif',
    '[瓢虫]': '173.gif',
    '[便便]': '174.gif',
    '[月亮]': '175.gif',
    '[太阳]': '176.gif',
    '[礼物]': '177.gif',
    '[拥抱]': '178.gif',
    '[强]': '179.gif',
    '[弱]': '180.gif',
    '[握手]': '181.gif',
    '[胜利]': '182.gif',
    '[抱拳]': '183.gif',
    '[勾引]': '184.gif',
    '[拳头]': '185.gif',
    '[差劲]': '186.gif',
    '[爱你]': '187.gif',
    '[NO]': '188.gif',
    '[OK]': '189.gif',
    '[爱情]': '190.gif',
    '[飞吻]': '191.gif',
    '[跳跳]': '192.gif',
    '[发抖]': '193.gif',
    '[怄火]': '194.gif',
    '[转圈]': '195.gif',
    '[磕头]': '196.gif',
    '[回头]': '197.gif',
    '[跳绳]': '198.gif',
    '[投降]': '199.gif'
}
 
export function decodeDom2(data: string) {

    if (!data||data.length == 0) return "";
    data = data.replace(/<br>/g, "");
    data = data.replace(/&amp;/g, "&");
    data = data.replace(/&lt;/g, "<");
    data = data.replace(/&gt;/g, ">");
    data = data.replace(/&nbsp;/g, " ");
    data = data.replace(/&#39;/g, "\'");
    data = data.replace(/&quot;/g, "\"");
    data = data.replace(/<\s?img[^>]*img-key=['"]([^'"]+)[^>]*>/gi, function (d, j) {
        var m = d.match(/\[(.+?)\]/g);
        if (!m) { return d }
        var _emoji = m[0];
        if (EMOJI_MAP[_emoji]) {
            return _emoji;
        }
        else if (_emoji == "[" + MEDIA_IMG + "]") {
             
            var src =d.match(/src=[\'\"]?([^\'\"]*)[\'\"]?/i)[1];
            return '[' + MEDIA_IMG + '=' + src + ']';
        }
        return d;
    });

    data =data.replace(/<file-element(([\s\S])*?)<\/file-element>/g, function (d, j) {
        var m = d.match(/\[(.+?)\]/g);
        if (!m) { return d }
        var key = m[0];
        if (key == "[" + MEDIA_FILE + "]") {
            var src =d.match(/taskid=[\'\"]?([^\'\"]*)[\'\"]?/i)[1];
            return '[' + MEDIA_FILE + '=' + src + ']';
        }
        return d;
    });
    return data;
}
 

export function decodeEmoji(text: string): Array<MessageElement> {
    var data: Array<MessageElement> = [];
    let temp = text;

    temp = text.replace(/&/g, "&");
    temp = temp.replace(/<br>/g, "");
    temp = temp.replace(/</g, "<");
    temp = temp.replace(/>/g, ">");
    temp = temp.replace(/\s/g, " ");
    temp = temp.replace(/\'/g, "'");
    temp = temp.replace(/\"/g, "\"");
    let left = -1
    let right = -1
    while (temp !== '') {
        left = temp.indexOf('[')
        right = temp.indexOf(']')
        switch (left) {
            case 0:
                if (right === -1) {
                    data.push({
                        type: 0,
                        value: temp
                    })
                    temp = ''
                } else {
                    let _emoji = temp.slice(0, right + 1)

                    if (EMOJI_MAP[_emoji]) {
                        data.push({
                            type: 1,
                            value: EMOJI_URL + EMOJI_MAP[_emoji],
                            name: _emoji
                        })
                        temp = temp.substring(right + 1)
                    } else if (_emoji.indexOf(MEDIA_IMG) != -1) {
                        var img = _emoji.replace('[' + MEDIA_IMG + '=', '').replace(']', '');
                        data.push({
                            type: 1,
                            value: img,
                            name: MEDIA_IMG
                        })
                        temp = temp.substring(right + 1)
                    }
                    else {
                        data.push({
                            type: 0,
                            value: '[',

                        })
                        temp = temp.slice(1)
                    }
                }
                break
            case -1:
                data.push({
                    type: 0,
                    value: temp
                })
                temp = ''
                break
            default:
                data.push({
                    type: 0,
                    value: temp.slice(0, left)
                })
                temp = temp.substring(left)
                break
        }
    }

    return data;
}

export function decodeText(temp) {
    var data: Array<MessageElement> = [];
    var push = function (item: MessageElement) {
        if (data.length > 0) {
            var lastItem = data[data.length - 1];
            if (lastItem.type == 0 && item.type == 0) {
                lastItem.value += item.value;
                return;
            }
        }
        data.push({
            type: item.type,
            value: item.value,
            name: item.name
        });
    }
    temp = temp.replace(/&/g, "&");
    temp = temp.replace(/</g, "<");
    temp = temp.replace(/>/g, ">");
    temp = temp.replace(/\s/g, " ");
    temp = temp.replace(/\'/g, "'");
    temp = temp.replace(/\"/g, "\"");
    let left = -1
    let right = -1
    while (temp !== '') {
        left = temp.indexOf('[')
        right = temp.indexOf(']')
        switch (left) {
            case 0:
                if (right === -1) {
                    push({
                        type: 0,
                        value: temp
                    });
                    temp = ''
                } else {
                    let _key = temp.slice(0, right + 1)
                    if (EMOJI_MAP[_key] && EMOJI_MAP[_key] != undefined) {
                        push({
                            type: 0,
                            value: _key
                        });
                        temp = temp.substring(right + 1)
                    } else if (_key.indexOf(MEDIA_IMG) != -1) {
                        var img = _key.replace('[' + MEDIA_IMG + '=', '').replace(']', '');
                        push({
                            type: 1,
                            value: img,
                            name: MEDIA_IMG
                        })
                        temp = temp.substring(right + 1)
                    }else if(_key.indexOf(MEDIA_FILE) != -1){
                        var file = _key.replace('[' + MEDIA_FILE + '=', '').replace(']', '');
                        push({
                            type: 5,
                            value: file,
                            name: MEDIA_FILE
                        })
                        temp = temp.substring(right + 1)

                    }
                    else {
                        push({
                            type: 0,
                            value: '['
                        });
                        temp = temp.slice(1)
                    }

                }
                break
            case -1:
                push({
                    type: 0,
                    value: temp
                });
                temp = ''
                break
            default:
                push({
                    type: 0,
                    value: temp.slice(0, left)
                })
                temp = temp.substring(left)
                break
        }
    }

    return data;
}